export default __webpack_public_path__ + "static/media/portal-do-fornecedor-emissao-etiqueta-de-expedicao_manual-de-etiquetas.9b66b9ef.pdf";